<template>
  <div class="charging-success">
    <b-card class="text-center text-gray03 pb-4">
      <img
        class="axel-success"
        src="../../../assets/payment/axel-success.svg"
      />
      <h2 class="text-septenary text-bold">{{ labels.title }}</h2>
      <h4 class="mb-3 text-bold">{{ labels.subtitle }}</h4>
      <p class="text-bold">{{ labels.message }}</p>

      <b-button
        variant="red02"
        class="pl-5 pr-5"
        @click="$router.push({ name: 'dashboard' })"
      >
        {{ labels.backToDashboard }}
      </b-button>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),

    labels: function() {
      return this.resources.page.home.charginSuccess
    },
  },
}
</script>

<style lang="scss" scoped>
.charging-success {
  margin-top: 7rem;

  @media (max-width: 425px) {
    margin-top: 1rem;
  }

  .text-bold {
    font-weight: bold !important;
  }

  .axel-success {
    height: 200px;
    margin-bottom: 30px;
    margin-top: -120px;

    @media (max-width: 425px) {
      height: 120px;
      margin-top: 20px;
    }
  }
}
</style>
